module.exports = {
  home: {
    path: `/`,
    component: 'src/pages/Home/index.js',
    context: {
      stepName: 'home',
    },
  },
  newLp: {
    path: `/baixe-o-aplicativo`,
    component: 'src/pages/QrCode/index.js',
    context: {
      stepName: 'home',
    },
  },
  uniclassLp: {
    path: `/uniclass/`,
    component: 'src/pages/UniclassLP/index.js',
  },
  personnaliteLp: {
    path: `/personnalite/`,
    component: 'src/pages/PersonnaliteLP/index.js',
  },
  document: {
    path: `/etapa/cpf/`,
    component: 'src/pages/Proposal/steps/Document/index.js',
    context: {
      stepName: 'cpf',
      segmentName: 'form-one-itau-cpf',
    },
  },
  name: {
    path: `/etapa/nome-completo/`,
    component: 'src/pages/Proposal/steps/Name/index.js',
    context: {
      stepName: 'nome',
      segmentName: 'form-one-itau-name',
    },
  },
  email: {
    path: `/etapa/email/`,
    component: 'src/pages/Proposal/steps/Email/index.js',
    context: {
      stepName: 'email',
      segmentName: 'form-one-itau-email',
    },
  },
  cellphone: {
    path: `/etapa/celular/`,
    component: 'src/pages/Proposal/steps/Cellphone/index.js',
    context: {
      stepName: 'celular',
      segmentName: 'form-one-itau-phone',
    },
  },
  otp: {
    path: `/etapa/otp/`,
    component: 'src/pages/Proposal/steps/OTP/index.js',
    context: {
      stepName: 'otp',
      segmentName: 'form-one-itau-otp',
    },
  },
  redirectOrangeCarpet: {
    path: `/etapa/redirecionamento/`,
    component: 'src/pages/Proposal/steps/RedirectCarpet/index.js',
    context: {
      stepName: 'redirect-carpet',
      segmentName: 'form-one-itau-otp',
    },
  },
  redirect: {
    path: `/baixe-o-app/`,
    component: 'src/pages/Redirect/index.js',
    context: {
      stepName: 'redirect',
      segmentTracking: 'form-one-itau-redirect',
    },
  },
  error: {
    path: `/erro/`,
    component: 'src/pages/Error/index.js',
  },
  maintenance: {
    path: `/sistema-indisponivel/`,
    component: 'src/pages/UnbalancedSystem/index.js',
  },
  notFound404: {
    path: '/pagina-nao-encontrada/',
    component: 'src/pages/NotFound/404.js',
  },
};
